<template>
  <BreadCrumb PageTitle="Scrollspy" />
  <ScrollspyContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ScrollspyContent from "../../template-components/UIElements/Scrollspy/ScrollspyContent.vue";

export default defineComponent({
  name: "ScrollspyPage",
  components: {
    BreadCrumb,
    ScrollspyContent,
  },
});
</script>